export { DetailsOfExpensesReport } from './DetailsOfExpensesReport.main';
